import React from 'react'
import { View } from 'react-native'
import { Observer } from 'mobx-react-lite'
import { TextBodySecondary, TextHeading } from '../atoms'
import ErrorBoundary from '../ErrorBoundary'
import findPath from '../../utils/helpers/findPath'
import Spacer from '../atoms/Spacer'
import { CoOwner } from '@linqpal/models/src/mst/CoOwners'
import { getSnapshot } from 'mobx-state-tree'

const PageComponent = ({
  data,
  coOwnerData,
  route,
  item,
  group,
  flow,
  document,
}) => {
  const pageDescription = flow[group][item]

  return (
    <pageDescription.component
      document={document}
      currentData={data}
      route={route}
      coOwnerData={coOwnerData?.content}
      onValue={(value, next, allMandatoryFilled) => {
        document.setData(
          item,
          value,
          pageDescription.title,
          group,
          flow[group].title,
          allMandatoryFilled,
        )
        const pathList =
          document.type === 'loan_application'
            ? findPath(flow, 'businessInfo', 'describeYourSelf', document)
            : findPath(flow, group, item, document)
        const groupIndex = Array.from(document.data.keys()).indexOf(group)
        const row = document.data.get(group).get(item, true)
        const itemIndex = document.data.get(group).items.indexOf(row)
        // console.log(groupIndex, itemIndex)
        // console.log(pathList)
        document.clearData((i, ix, group, gix) => {
          let exists = pathList.includes(`${group}.${i.identifier}`)
          if (
            gix < groupIndex ||
            (gix === groupIndex && ix <= itemIndex) ||
            i.content?.allMandatoryFilled
          ) {
            exists = true
          }
          // console.log(gix, ix, group, i.identifier, exists)
          return exists
        })
        if (next) {
          if (typeof next === 'function') {
            document.setCurrent(next(document))
          } else {
            document.setCurrent(next)
          }
        } else if (typeof pageDescription.next === 'function') {
          const n = pageDescription.next(document)
          document.setCurrent(n)
        } else {
          document.setCurrent(pageDescription.next)
        }
      }}
      onSkip={() => {
        document.removeData(group, item)
        if (typeof pageDescription.next === 'function') {
          const n = pageDescription.next(document)
          document.setCurrent(n)
        } else {
          document.setCurrent(pageDescription.next)
        }
      }}
      onValueForCoOwner={(value, identifier) => {
        document.removeData('coOwnerInfo', identifier)
        const ownerData = document.data
          .get('coOwnerInfo')
          ?.get(coOwnerData.identifier)
        const owner = CoOwner.create(ownerData ?? {})
        if (typeof value === 'object') {
          Object.keys(value).forEach((item) => {
            owner.setValue(item, value[item])
          })
        } else {
          owner.setValue(identifier, value)
        }
        document?.setData(
          coOwnerData.identifier,
          {
            ...getSnapshot(owner),
            allMandatoryFilled: owner.allMandatoryFilled,
          },
          'Co-owner details',
          'coOwnerInfo',
          'Business Co-owner information',
          owner.allMandatoryFilled,
        )
        document.setCurrent(
          typeof pageDescription.next === 'function'
            ? pageDescription.next(document)
            : pageDescription.next,
        )
      }}
    />
  )
}

function Document({ flow, initial, document, closeMe, style, type, ...props }) {
  if (!document || document.type !== type) return null
  const [group, item] = (document.current || initial).split('.')
  let pageDescription = flow[group][item]

  return (
    <View style={[{ flex: 1 }, style]}>
      <View
        style={{
          flexDirection: 'row',
          marginBottom: 10,
        }}
      >
        <TextHeading
          style={{
            marginHorizontal: 23,
            marginTop: 15,
            lineHeight: 28,
            fontSize: 22,
          }}
        >
          {pageDescription?.title}
        </TextHeading>
      </View>
      <TextBodySecondary
        style={{
          fontWeight: '300',
          fontSize: 15,
          lineHeight: 22,
          marginTop: 0,
          paddingHorizontal: 23,
          alignSelf: 'center',
        }}
      >
        {pageDescription?.description}
      </TextBodySecondary>
      <Spacer />
      <View style={{ flex: 1 }}>
        {pageDescription && pageDescription.component && (
          <ErrorBoundary Fallback={<PageComponent data={null} />}>
            <Observer>
              {() => (
                <PageComponent
                  data={document.currentData}
                  document={document}
                  flow={flow}
                  group={group}
                  item={item}
                  {...props}
                />
              )}
            </Observer>
          </ErrorBoundary>
        )}
      </View>
    </View>
  )
}

export default Document
